export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gray-900 text-white py-16">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-16">
          <div>
            <h3 className="text-base font-semibold mb-4">Products</h3>
            <div className="h-px bg-white/30 w-16 mb-4"></div>
            <ul className="space-y-3">
              <li>
                <button onClick={() => scrollToSection('products')} className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer">
                  VPN
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('products')} className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer">
                  Cleaner
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-base font-semibold mb-4">Company</h3>
            <div className="h-px bg-white/30 w-16 mb-4"></div>
            <ul className="space-y-3">
              <li>
                <button onClick={() => scrollToSection('about')} className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer">
                  About Us
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('contact')} className="text-sm text-gray-400 hover:text-white transition-colors cursor-pointer">
                  Contact
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-base font-semibold mb-4">Resources</h3>
            <div className="h-px bg-white/30 w-16 mb-4"></div>
            <ul className="space-y-3">
              <li>
                <span className="text-sm text-gray-400">Documentation</span>
              </li>
              <li>
                <span className="text-sm text-gray-400">Support</span>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-base font-semibold mb-4">Legal</h3>
            <div className="h-px bg-white/30 w-16 mb-4"></div>
            <ul className="space-y-3">
              <li>
                <span className="text-sm text-gray-400">Privacy Policy</span>
              </li>
              <li>
                <span className="text-sm text-gray-400">Terms of Service</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-12">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
            <div>
              <div className="text-xs uppercase text-gray-500 mb-2">Address</div>
              <div className="text-white text-sm mb-1">NADE DIMIC 2</div>
              <div className="text-xs uppercase text-gray-500 mb-2 mt-3">City</div>
              <div className="text-white text-sm mb-1">Subotica</div>
              <div className="text-xs uppercase text-gray-500 mb-2 mt-3">Zip</div>
              <div className="text-white text-sm mb-1">455710</div>
              <div className="text-xs uppercase text-gray-500 mb-2 mt-3">Country</div>
              <div className="text-white text-sm">Serbia</div>
            </div>

            <div>
              <div className="flex items-center gap-2 mb-3">
                <i className="ri-mail-line text-purple-400"></i>
                <div>
                  <div className="text-xs uppercase text-gray-500">Email</div>
                  <a href="mailto:contact@bratelidoo.com" className="text-white text-sm hover:text-purple-400 transition-colors cursor-pointer">
                    contact@bratelidoo.com
                  </a>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-phone-line text-purple-400"></i>
                <div>
                  <div className="text-xs uppercase text-gray-500">Number</div>
                  <a href="tel:+19044543991" className="text-white text-sm hover:text-purple-400 transition-colors cursor-pointer">
                    +1 9044543991
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="flex flex-col md:flex-row justify-between items-center gap-6">
            <div className="flex items-center gap-3">
              <img 
                src="https://public.readdy.ai/ai/img_res/7a8be81f-3d83-4111-ae92-138c8d65622c.png" 
                alt="BRATELI DOO Logo" 
                className="h-8 w-8 object-contain"
              />
              <div>
                <div className="text-2xl font-bold">BRATELI DOO</div>
                <div className="h-px bg-purple-500 w-20 mt-1"></div>
                <div className="text-xs text-gray-500 mt-1">iOS Development Experts</div>
              </div>
            </div>

            <div className="text-center md:text-right">
              <div className="text-sm text-gray-400 mb-2">© 2025 BRATELI DOO</div>
              <div className="flex items-center gap-4 justify-center md:justify-end">
                <i className="ri-linkedin-fill text-xl text-gray-400 hover:text-white transition-colors cursor-pointer"></i>
                <i className="ri-twitter-x-fill text-xl text-gray-400 hover:text-white transition-colors cursor-pointer"></i>
                <i className="ri-github-fill text-xl text-gray-400 hover:text-white transition-colors cursor-pointer"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}